<template>
  <div id="tabbed_filter">
    <CustomTabs
      v-model="activeTab"
      :tabs="tabOptions"
      contentPadding="pt-2"
      extra-header-styles="px-2"
      show-transition
    >
      <template
        v-for="(tab, index) in filter.tabs"
        :key="tab.id"
        v-slot:[`tab_content-${index}`]
      >
        <FilterOptionsList
          v-if="tab"
          :filter-id="tab.id"
          :filter-name="tab.name"
          :options="getFilterOptions(tab)"
          :searchable="tab.searchable"
          :show-initials="tab.showInitials"
          @select-option="(option) => handleOptionSelect(option, tab)"
          @search="handleSearch"
        />
      </template>
    </CustomTabs>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import CustomTabs from "@/src/components/CustomTabs.vue";
import FilterOptionsList from "./FilterOptionsList.vue";

const props = defineProps({
  filter: { type: Object, required: true },
  filterData: { type: Object, required: true },
});

const emit = defineEmits(["select-option", "search"]);

const activeTab = ref(0);

const tabOptions = computed(() => {
  return (
    props.filter.tabs?.map((tab) => ({
      title: tab.name,
      key: tab.id,
    })) || []
  );
});

const getFilterOptions = (tab) => {
  if (!tab || !tab.options) return [];

  return tab.options.map((option) => {
    return {
      ...option,
      selected: Array.isArray(props.filterData[tab.id])
        ? props.filterData[tab.id].includes(option.id)
        : props.filterData[tab.id] === option.id,
    };
  });
};

const handleOptionSelect = (option, tab) => {
  if (option.id !== null) {
    props.filter.tabs.forEach((otherTab) => {
      if (otherTab.id !== tab.id && props.filterData[otherTab.id]) {
        emit("select-option", { id: null }, otherTab);
      }
    });
  }

  emit("select-option", option, tab);
};

const handleSearch = (filterId, query) => {
  emit("search", filterId, query);
};

onMounted(() => {
  activeTab.value = activeTab.value;
});
</script>
